import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs';
import { LoaderService } from '@core/services/loader.service';

export const loaderInterceptor: HttpInterceptorFn = (request, next) => {
  if (request.headers.has('X-Skip-Loader')) {
    return next(request.clone({ headers: request.headers.delete('X-Skip-Loader') }));
  }

  const loader = inject(LoaderService);
  loader.show();

  return next(request).pipe(finalize(() => loader.hide()));
};
